import moment, { Moment } from 'moment';

export const formatDate = (date: Moment | string, formatPattern = 'DD.MM.YYYY') => {
    if (typeof date === 'string' && date.length === 0) {
        return '';
    }
    const formatted = moment(date, 'DD.MM.YYYY');
    return moment(formatted).format(formatPattern);
};
